<template>
  <div>
    <el-card>
      <el-table :data="list" v-loading="loading" border style="width: 100%">
        <el-table-column prop="sanboQuestionnaireVo.title" label="问卷名称"></el-table-column>
        <el-table-column prop="sanboQuestionnaireVo.typeName" label="健康自评分数"></el-table-column>
        <el-table-column prop="sanboQuestionnaireVo.description" label="问卷描述"></el-table-column>
        <el-table-column prop="sanboQuestionnaireVo。createTime" label="创建时间" :formatter="formattercreateTime"></el-table-column>
        <el-table-column
          prop="completeTextValue"
          label="完成度"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="details(scope.row.sanboQuestionnaireVo.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      memberInfo: "",
      list: [],
      loading: false,
      value: "",
      tabTypeId:''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    formattercreateTime(row) {
      return this.getDate(row.sanboQuestionnaireVo.createTime);
    },
    details(id){
      this.$router.push({ path: "questionnaireDetails",query: { id: id,memberId:this.$route.query.id}});
    },
    getDate(tm) {
      var tt = new Date(parseInt(tm))
        .toLocaleString()
        .replace(/年|月/g, "-")
        .replace(/日/g, "        ");
      return tt;
    },
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.questionnaire.list",
          memberId:_this.$route.query.id,
          source:'SANBOYUN'
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.list=obj.sanboQuestionnaireList;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>
<style scoped>
</style>